/* eslint-disable max-lines */
function modifyUsers(state, data) {
    let users = {};

    if (state && state.users) {
        users = Object.assign({}, state.users);
    }
    users[data.user.id] = data.user;

    return users;
}

function modifyMessages(state, data) {
    let messages = {};

    if (state && state.messages) {
        messages = Object.assign({}, state.messages);
    }
    messages[data.message.id] = data.message;

    return messages;
}

function modifyMessageList(state, data) {
    let messages = {};

    if (state && state.messages) {
        messages = Object.assign({}, state.messages);
    }
    if (data.messages && data.messages.length) {
        data.messages.forEach(message => {
            messages[message.id] = message;
        });
    }

    return messages;
}

function checkMessageStatusChange(state, data) {
    let messages = {};
    let messageStatusChange = false;
    const messageData = data.message;

    if (state && state.messages) {
        messages = Object.assign({}, state.messages);
    }
    if (messageData) {
        if (messages[messageData.id] && messages[messageData.id].displayed !== messageData.displayed) {
            messageStatusChange = true;
        }
    }

    return messageStatusChange;
}

function checkMessagesStatusChange(state, data) {
    let messages = {};
    let messageStatusChange = false;

    if (state && state.messages) {
        messages = Object.assign({}, state.messages);
    }
    if (data.messages && data.messages.length) {
        const messageList = data.messages;

        for (let iCounter = 0; iCounter < messageList.length; iCounter++) {
            const message = messageList[iCounter];

            if (messages[message.id] && messages[message.id].displayed !== message.displayed) {
                messageStatusChange = true;
                break;
            }
        }
    }

    return messageStatusChange;
}

function modifyThreads(state, data) {
    let threadMessages = {};
    const { userId, itemId } = data;
    const threadKey = `${userId}_${itemId}`;

    if (state && state.threadMessages) {
        threadMessages = { ...state.threadMessages };
    }
    if (typeof threadMessages[threadKey] === 'undefined') {
        threadMessages[threadKey] = [];
    }
    else {
        threadMessages[threadKey] = threadMessages[threadKey].slice(0);
    }
    let slicedIndex;

    const hasMessage = threadMessages[threadKey].filter((message, index) => {
        if (message.id === data.message.id) {
            slicedIndex = index;
            return true;
        }
        return false;
    });

    if (hasMessage.length) {
        threadMessages[threadKey].splice(slicedIndex, 1, data.message);
    }
    else {
        threadMessages[threadKey].push(data.message);
    }

    return threadMessages;
}

function modifyThreadList(state, data) {
    let threadMessages = {};

    if (state && state.threadMessages) {
        threadMessages = Object.assign({}, state.threadMessages);
    }
    if (data.messages && data.messages.length) {
        data.messages.forEach(message => {
            const { userId, itemId } = message;
            const threadKey = `${userId}_${itemId}`;

            if (typeof threadMessages[threadKey] === 'undefined') {
                threadMessages[threadKey] = [];
            }
            else {
                threadMessages[threadKey] = threadMessages[threadKey].slice(0);
            }
            let slicedIndex;

            const hasMessage = threadMessages[threadKey].filter((msg, index) => {
                if (msg.id === message.id) {
                    slicedIndex = index;
                    return true;
                }
                return false;
            });

            if (hasMessage.length) {
                threadMessages[threadKey].splice(slicedIndex, 1, message);
            }
            else {
                threadMessages[threadKey].push(message);
            }
        });
    }

    return threadMessages;
}

function modifyNewThreads(state, data) {
    let threads = [];

    if (state && state.threads) {
        threads = state.threads.slice(0);
    }

    data.threads.forEach(thread => {
        threads = threads.filter(t => t.id !== thread.id);
    });

    threads = threads.concat(data.threads);

    return threads;
}

function modifyNewThread(state, data) {
    let threads = [];
    const { threadId, updates } = data;

    if (state && state.threads) {
        threads = state.threads.slice(0);
    }

    threads = threads.map(thread => {
        if (thread.id === threadId) {
            return {
                ...thread,
                ...updates
            };
        }
        return thread;
    });

    return threads;
}

function deleteMessages(state, data) {
    let messages = {};

    if (state && state.messages) {
        messages = Object.assign({}, state.messages);
    }

    if (data.itemId && data.userId) {
        const msgs = Object.values(messages);

        msgs.forEach(message => {
            if (message.userId === data.userId && message.itemId === data.itemId) {
                delete messages[message.id];
            }
        });
    }
    else if (data.userId) {
        const msgs = Object.values(messages);

        msgs.forEach(message => {
            if (message.userId === data.userId) {
                delete messages[message.id];
            }
        });
    }

    return messages;
}

function deleteBulkMessages(state, data) {
    let messages = {};

    if (state && state.messages) {
        messages = Object.assign({}, state.messages);
    }

    if (Object.values(data).length) {
        const msgs = Object.values(messages);

        msgs.forEach(message => {
            if (Object.prototype.hasOwnProperty.call(data, `${message.userId}_${message.itemId}`)) {
                delete messages[message.id];
            }
        });
    }

    return messages;
}

function deleteMessage(state, data) {
    let messages = {};

    if (state && state.messages) {
        messages = Object.assign({}, state.messages);
    }

    if (data.messageId) {
        delete messages[data.messageId];
    }

    return messages;
}

function deleteBulkThreads(state, data) {
    let threadMessages = {};

    if (state && state.threadMessages) {
        threadMessages = Object.assign({}, state.threadMessages);
    }
    if (Object.values(data).length) {
        Object.keys(threadMessages).forEach(userItem => {
            if (Object.prototype.hasOwnProperty.call(data, userItem)) {
                delete threadMessages[userItem];
            }
        });
    }
    return threadMessages;
}

function deleteThreads(state, data) {
    let threadMessages = {};

    if (state && state.threadMessages) {
        threadMessages = Object.assign({}, state.threadMessages);
    }

    if (data.itemId && data.userId) {
        delete threadMessages[`${data.userId}_${data.itemId}`];
    }
    else if (data.userId) {
        const userItems = Object.keys(threadMessages);

        userItems.forEach(userItem => {
            const userId = userItem.split('_')[0];

            if (userId === data.userId) {
                delete threadMessages[userItem];
            }
        });
    }

    return threadMessages;
}

function deleteBulkNewThreads(state, data) {
    let threads = [];

    if (state && state.threads) {
        threads = state.threads.slice(0);
    }

    if (Object.values(data).length) {
        threads = threads.filter(thread => !Object.prototype.hasOwnProperty.call(data, `${thread.userId}_${thread.itemId}`));
    }

    return threads;
}

function deleteNewThreads(state, data) {
    let threads = [];

    if (state && state.threads) {
        threads = state.threads.slice(0);
    }

    threads = threads.filter(thread => !(thread.userId === data.userId && thread.itemId === data.itemId));

    return threads;
}

function deleteMessageFromThread(state, data) {
    let threadMessages = {};

    if (state && state.threadMessages) {
        threadMessages = Object.assign({}, state.threadMessages);
    }

    if (data.itemId && data.userId) {
        threadMessages[`${data.userId}_${data.itemId}`] = threadMessages[`${data.userId}_${data.itemId}`].filter(message => message.id != data.messageId);
        if (!threadMessages[`${data.userId}_${data.itemId}`].length) {
            delete threadMessages[`${data.userId}_${data.itemId}`];
        }
    }

    return threadMessages;
}
function getReplyRistrictionMetaData(state, data) {
    let replyRestriction = {};

    if (state && state.replyRestriction) {
        replyRestriction = Object.assign({}, state.replyRestriction);
    }

    replyRestriction.error_text = data.reply_restriction_error_text;
    replyRestriction.user_error_text = data.reply_restriction_user_error_text;

    return replyRestriction;
}
function initAllThreadsQuestionCloud(questionCloudArr) {
    return questionCloudArr.reduce((acc, curr) => {
        const { userItemId, ...rest } = curr;

        acc[userItemId] = rest;
        return acc;
    }, {});
}
function updateQuestionCloud(questionCloud, data) {
    return {
        ...questionCloud,
        ...data
    };
}
const defaultState = {
    isThreadsFetched: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'SAVE_CONVERSATION_LIST':
            return {
                ...state,
                conversationList: action.data
            };
        case 'SAVE_SAFETY_TIPS':
            return {
                ...state,
                safetyTips: action.data
            };

        case 'SAVE_REPLY_RESTRICTION_METADATA' :
            return {
                ...state,
                replyRestrictionMetaData: getReplyRistrictionMetaData(state, action.data)
            };
        case 'SAVE_KYC_REPLY_RESTRICTION_METADATA' :
            return {
                ...state,
                kycRestrictionMetaData: getReplyRistrictionMetaData(state, action.data)
            };
        case 'SAVE_MESSAGE':
            return {
                ...state,
                messages: modifyMessages(state, action.data),
                threadMessages: modifyThreads(state, action.data),
                didMessageStatusChange: checkMessageStatusChange(state, action.data)
            };
        case 'SAVE_MESSAGES':
            return {
                ...state,
                messages: modifyMessageList(state, action.data),
                threadMessages: modifyThreadList(state, action.data),
                didMessageStatusChange: checkMessagesStatusChange(state, action.data)
            };
        case 'REMOVE_MESSAGES':
            return {
                ...state,
                messages: deleteMessages(state, action.data),
                threadMessages: deleteThreads(state, action.data),
                threads: deleteNewThreads(state, action.data)
            };
        case 'REMOVE_BULK_MESSAGES':
            return {
                ...state,
                messages: deleteBulkMessages(state, action.data),
                threadMessages: deleteBulkThreads(state, action.data),
                threads: deleteBulkNewThreads(state, action.data)
            };
        case 'REMOVE_MESSAGE':
            return {
                ...state,
                messages: deleteMessage(state, action.data),
                threadMessages: deleteMessageFromThread(state, action.data)
            };
        case 'SAVE_THREADS':
            return {
                ...state,
                threads: modifyNewThreads(state, action.data)
            };
        case 'FETCH_THREADS':
            return {
                ...state,
                isThreadsFetched: true
            };
        case 'UPDATE_THREAD':
            return {
                ...state,
                threads: modifyNewThread(state, action.data)
            };
        case 'SAVE_USER':
            return {
                ...state,
                users: modifyUsers(state, action.data)
            };
        case 'SAVE_CONVERSATION': {
            const data = Object.assign({}, state && state.conversation || {});

            data[action.id] = action.data;
            return {
                ...state,
                conversation: data
            };
        }
        case 'REMOVE_CONVERSATION': {
            const obj = Object.assign({}, state && state.conversation || {});

            delete obj[action.id];
            return {
                ...state,
                conversation: obj
            };
        }
        case 'SHOW_LOAD_MORE':
            return {
                ...state,
                shouldLoadMore: action.data && action.data.pageToken
            };
        case 'SET_BATCH_INDEX': {
            return {
                ...state,
                batchIndex: action.data
            };
        }
        case 'SET_OFFSET_INDEX': {
            return {
                ...state,
                offsetIndex: action.data
            };
        }
        case 'SET_TOTAL_UNREAD_COUNT': {
            return {
                ...state,
                totalUnreadCount: action.data
            };
        }
        case 'SAVE_SYSTEM_MESSAGE_DATA': {
            return {
                ...state,
                systemMessageData: action.data
            };
        }
        case 'INIT_QUESTION_CLOUD':
            return {
                ...state,
                questionCloud: initAllThreadsQuestionCloud(action.data)
            };
        case 'SAVE_QUESTIONS':
            return {
                ...state,
                questionCloud: updateQuestionCloud(state.questionCloud, action.data)
            };
        case 'CHAT_SET_QUICK_FILTERS':
            return {
                ...state,
                quickFilters: action.data
            };
        case 'LOGOUT':
            return null;
        default:
            return state || null;
    }
};
